import React, { useState } from 'react';
import { getInitials, getClubHue } from './clubVisuals';

interface ClubThumbnailProps {
  id: string;
  bannerUrl?: string | null;
  name: string;
  size: number;
}

export const ClubThumbnail: React.FC<ClubThumbnailProps> = ({ id, bannerUrl, name, size }) => {
  const [imgError, setImgError] = useState(false);

  const showImage = !!bannerUrl && !imgError;

  const hue = getClubHue(id);
  const initials = getInitials(name);

  return (
    <div
      className="overflow-hidden rounded-[11px] shrink-0"
      style={{ width: size, height: size }}
    >
      {showImage ? (
        <img
          src={bannerUrl!}
          className="h-full w-full object-cover"
          alt={name}
          onError={() => setImgError(true)}
        />
      ) : (
        <div
          className="h-full w-full flex items-center justify-center font-bold"
          style={{
            background: `hsl(${hue} 32% 92%)`,
            color: `hsl(${hue} 28% 45%)`,
            fontSize: size * 0.36,
          }}
        >
          {initials}
        </div>
      )}
    </div>
  );
};
